<template>
    <div name="third-party">
        <h2>[개인정보 제3자 제공 동의]</h2>
        유전자검사 서비스 이용과 관련하여 본인의 개인정보를 제3자에게 제공하고자 하는 경우에는<br>
        「개인정보보호법」 등 관계 법령에 따라 본인의 동의가 필요합니다.<br>
        ({{ hospital_name }} 의료기관)에서는 아래와 같이 수집한 귀하의 개인정보를 {{company_name}}에게 제공하고자 합니다. 수집된 정보는 귀하가 동의한 내용 외 다른 목적으로 이용되지 않으며 개인정보는 언제든 열람, 정정, 삭제를 요구할 수 있습니다.


         <table border="1" style="margin-top: 12px;">
            <thead>
                <tr>
                    <th>제공받는 자</th>
                    <th>제공 목적</th>
                    <th>제공 항목</th>
                    <th>제공받는 자의 보유 및 이용기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{company_name}}</td>
                    <td>보험 컨설팅 제공</td>
                    <td>성명, 생년월일, 주소, 전화번호, 성별</td>
                    <td>수집 일로부터 10년간 혹은 철회 시까지</td>
                </tr>  
            </tbody>
        </table><br>
    </div>
</template>

<script>
export default {
    name: 'thirdParty',
    data: function()
    {
        return {
            company_name: '',
            hospital_name: ''
        }
    },
    mounted: function()
    {
        this.company_name = this.$route.query.company_name;
        this.hospital_name = this.$route.query.hospital_name;
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/genetic/PrivacyThirdPartyContent.vue